<div class="header">
  <h3>รายชื่อผู้ใช้งานระบบ</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" [(ngModel)]="searchUsername" placeholder="ชื่อผู้ใช้" autocomplete="off">
        <label for="username">ชื่อผู้ใช้</label>
      </div>
    </div>
    <div class="col">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="group"
          [options]="groups"
          [(ngModel)]="searchGroup"
          [autoDisplayFirst]="false"
          placeholder="สิทธิ์การใช้งาน"
        >
        </p-dropdown>
        <label for="group">สิทธิ์การใช้งาน</label>
      </div>
    </div>
  </div>

  <div class="col mt-2">
    <div *ngIf="errorMessage" class="text-right text-red">
      {{ errorMessage }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="optionChanged()"
  >
    <button type="button" class="btn btn-dv btn-wide" (click)="openModal(null, -1)">เพิ่มผู้ใช้งาน</button>
  </app-custom-pagination>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="!loading">
      <thead>
      <tr>
        <th scope="col">ลำดับ</th>
        <th scope="col">Username</th>
        <th scope="col">Role</th>
        <th scope="col">Company</th>
        <th scope="col">สิทธิ์ขอเปลี่ยนสถานะและจำนวนเงิน</th>
        <th scope="col">สิทธิ์ขอลบเอกสาร</th>
        <th scope="col">Status</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let res of list; let index = index">
        <td (click)="openModal(res, index)" >{{((currentPage - 1) * itemsPerPage) + index + 1}}</td>
        <td (click)="openModal(res, index)" >{{res.username}}</td>
        <td (click)="openModal(res, index)" >{{res.group.name}}</td>
        <td>
          <div ngbDropdown class="d-inline-block">
          <button style="background: #02008a" class="btn btn-primary" id="dropdownBasic1"
                  ngbDropdownToggle>บริษัทที่เข้าถึง</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <p class="backgroundcompany" ngbDropdownItem
             *ngFor="let company of res.company_group">{{company.name}}</p>
            </div>
          </div>
        </td>
        <td>
          <label class="switch">
            <input type="checkbox"
                   [checked]="res.can_change_status_amount"
                   (click)="changePermissionAccess(res, 'change_status_amount')">
            <span class="slider round"></span>
          </label>
        </td>
        <td>
          <label class="switch">
            <input type="checkbox"
                   [checked]="res.can_delete_document"
                   (click)="changePermissionAccess(res, 'delete_document')">
            <span class="slider round"></span>
          </label>
        </td>
        <td class="align-text-top" (click)="openModal(res, index)" >
          <div *ngIf="res.is_active">เปิดการใช้งาน</div>
          <div *ngIf="!res.is_active">ถูกระงับการใช้งาน</div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<profile-list-detail #detailModal></profile-list-detail>




// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list/profile-list.component.html